module.exports = __webpack_public_path__ + "img/client-wash_takeout_tw.7686dc20.svg";